import {
  postLogin,
  postLogout,
  postChangePassword,
  postForgotPassword,
  postResetPassword,
} from "../../api/auth";
import { createSliceWithThunks } from "../utils";

const initialState = {
  activeSession: sessionStorage.getItem("activeSession")
    ? JSON.parse(sessionStorage.getItem("activeSession"))
    : null,
  login: {
    data: null,
    status: "idle",
    error: null,
  },
  otp: {
    data: null,
    status: "idle",
    error: null,
  },
  password: {
    data: null,
    status: "idle",
    error: null,
  },
};

export const authSlice = createSliceWithThunks({
  name: "authSlice",
  initialState: initialState,
  reducers: (create) => ({
    resetStateAuth: create.reducer((state, { payload }) => {
      if (payload) {
        for (let key in payload) {
          state[`${payload[key]}`] = initialState[`${payload[key]}`];
        }
      } else {
        for (let key in initialState) {
          state[key] = initialState[key];
        }
      }
    }),
    logout: create.reducer((state) => {
      state.activeSession = null;
      window.location.replace("/");
      sessionStorage.removeItem("activeSession");
    }),
    //* thunks
    userLogin: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await postLogin(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.login.status = "loading";
        },
        rejected: (state, action) => {
          state.login.status = "failed";
          state.login.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            if (data?.type === "success") {
              sessionStorage.setItem(
                "activeSession",
                JSON.stringify(data?.data)
              );
              state.activeSession = data?.data;
              state.login.data = "Login successful";
            } else {
              state.login.error = {
                message: data?.data || data?.message || "An error occurred",
              };
            }
          } else {
            state.login.error = {
              message: data?.data || data?.message || "An error occurred",
            };
          }
          state.login.status = "idle";
        },
      }
    ),
    userLogout: create.asyncThunk(
      async ({ rejectWithValue }) => {
        try {
          const response = await postLogout();
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {},
        rejected: (state, action) => {},
        fulfilled: (state, { payload }) => {},
      }
    ),
    changePassword: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await postChangePassword(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.password.status = "loading";
        },
        rejected: (state, action) => {
          state.password.status = "failed";
          state.password.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200 || status === 202) {
            if (data?.type === "success") {
              state.password.data = data?.data;
            } else {
              state.password.error = {
                message: data?.data || data?.message || "An error occurred",
              };
            }
          } else {
            state.password.error = {
              message: data?.data || data?.message || "An error occurred",
            };
          }
          state.password.status = "idle";
        },
      }
    ),
    forgotPassword: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await postForgotPassword(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.otp.status = "loading";
        },
        rejected: (state, action) => {
          state.otp.status = "failed";
          state.otp.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200 || status === 202) {
            if (data?.type === "success") {
              state.otp.data = data?.data;
            } else {
              state.otp.error = {
                message: data?.data || data?.message || "An error occurred",
              };
            }
          } else {
            state.otp.error = {
              message: data?.data || data?.message || "An error occurred",
            };
          }
          state.otp.status = "idle";
        },
      }
    ),
    resetPassword: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await postResetPassword(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.password.status = "loading";
        },
        rejected: (state, action) => {
          state.password.status = "failed";
          state.password.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200 || status === 202) {
            if (data?.type === "success") {
              state.password.data = data?.data;
            } else {
              state.password.error = {
                message: data?.data || data?.message || "An error occurred",
              };
            }
          } else {
            state.password.error = {
              message: data?.data || data?.message || "An error occurred",
            };
          }
          state.password.status = "idle";
        },
      }
    ),
  }),
});

export const {
  resetStateAuth,
  logout,
  userLogin,
  userLogout,
  changePassword,
  forgotPassword,
  resetPassword,
} = authSlice.actions;
export default authSlice.reducer;
